/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateChildFirmQuestion = {
  readonly id?: number;
  name: string;
  question_type?: UpdateChildFirmQuestion.question_type;
  options?: Array<string>;
  firm: number;
  description?: string | null;
};
export namespace UpdateChildFirmQuestion {
  export enum question_type {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
  }
}
